const extract = {
    inserted: (el) => {
        let strArray = el.textContent.split(''), res = ''
        strArray.map((e, k)=>{ if(e === ' ') strArray.splice(k, 1)})
        strArray.map((e)=> res += e)
        el.innerText = res
    },
    update: (el) => {
        let strArray = el.textContent.split(''), res = ''
        strArray.map((e, k)=> {if (e === ' ') strArray.splice(k, 1)})
        strArray.map((e)=> res += e)
        el.innerText = res
    },
}
export default extract